import { detect } from 'detect-browser';

export const isChrome = () => {
    const browser = detect();
    if (!browser || !browser.os || !browser.name) {
        return false;
    }
    return browser.name === 'chrome';
};
